import { Typography } from '@mui/material';

function HeaderMenu() {
  return <></>;
}

export default HeaderMenu;
